import { Products } from "@app/models/Products";
import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";

@Injectable({ providedIn: "root" })
export class ProductApi  extends HOAApiBase {

    constructor() {
        super('ProductApi');
    }

    public fetchProductOrganization( pmcCouponId: string, hoaCouponId: string) {
        this.check({ pmcCouponId, hoaCouponId }, 'non-empty string', a => typeof a === 'string' && a.length > 0)

        return this.http.get<Products>(
            this.createUrl('HOAPass','/organization/products'),
            { params: {
                pmcCouponId: pmcCouponId,
                hoaCouponId: hoaCouponId
            } }
        );
    }
}

